import { render, staticRenderFns } from "./ModalBrigadePriority.vue?vue&type=template&id=778dbc9c&"
import script from "./ModalBrigadePriority.vue?vue&type=script&lang=js&"
export * from "./ModalBrigadePriority.vue?vue&type=script&lang=js&"
import style0 from "./ModalBrigadePriority.vue?vue&type=style&index=0&id=778dbc9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports